/**
 * External Imports
 */
import styled from 'styled-components';

export const TreeContainer = styled.div`
  height: 100vh;
`;
